
import React from "react";

interface FollowUpSuggestionsProps {
  onSuggestionClick: (question: string) => void;
  suggestions: string[];
  show: boolean;
}

const FollowUpSuggestions: React.FC<FollowUpSuggestionsProps> = ({
  onSuggestionClick,
  suggestions,
  show
}) => {
  // Disabled component - always returns null
  return null;
};

export default FollowUpSuggestions;
